import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { AdvertisingStore, initializeClear } from 'bernie-plugin-ads-loader-script';
import { ErrorBoundary } from 'bernie-view';

import { MesoTargeting } from './internals/meso-targeting';

interface MesoScriptsProps {
  advertising?: AdvertisingStore;
}

@inject('advertising')
@observer
export class MesoScripts extends React.Component<MesoScriptsProps> {
  public componentWillUnmount() {
    initializeClear();
  }

  public render() {
    const { advertising } = this.props;
    if (typeof window !== 'undefined' && advertising && advertising.triggeredPageName) {
      return (
        <AbacusExperiment name="PWA_large_screens_Ads">
          <AbacusControl />
          <AbacusVariant bucket={1}>
            <ErrorBoundary label="meso.scripts.errorboundary">
              <MesoTargeting />
            </ErrorBoundary>
          </AbacusVariant>
          <AbacusVariant bucket={2}>
            <ErrorBoundary label="meso.scripts.errorboundary">
              <MesoTargeting />
            </ErrorBoundary>
          </AbacusVariant>
        </AbacusExperiment>
      );
    }

    return null;
  }
}
